/*
 * gateway-pdp.js
 *
 * Buy behavior for The 9/9 Gateway Reading:
 * - one skippable ask writing to the ORDER NOTE ("What I've been giving
 *   myself to: ..."); blank writes nothing so fulfilment's safeguard asks
 * - clear the cart, add only this reading, write note, go directly to checkout
 * - live countdown to the real deadline (midnight on the 9th; hides after)
 * - sticky CTA from page load until the real button is on screen
 *   (plain scroll handler, correct initial state, no IO first-callback lag)
 */

(function () {
  const root = document.querySelector('[data-gw-root]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const JSON_HEADERS = { 'Content-Type': 'application/json' };

  const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
  const cartClearUrl = (root.dataset.cartClearUrl || '/cart/clear') + '.js';
  const cartAddUrl = (root.dataset.cartAddUrl || '/cart/add') + '.js';
  const cartUpdateUrl = (root.dataset.cartUpdateUrl || '/cart/update') + '.js';
  const variantId = root.dataset.variantId || '';

  function analytics(event, payload) {
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...(payload || {}) });
  }

  function buildNote() {
    const main = $('[data-ask-main]');
    if (main && main.value.trim()) return "What I've been giving myself to: " + main.value.trim();
    return '';
  }

  async function cartRequest(url, options) {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error('Cart request failed');
    return response;
  }

  async function addToCart(btn) {
    const errEl = $('[data-add-error]');
    if (!variantId) {
      if (errEl) { errEl.textContent = 'This reading is not available right now. Please check back soon.'; errEl.hidden = false; }
      return;
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (errEl) errEl.hidden = true;
    analytics('gateway_atc', {});
    try {
      await cartRequest(cartClearUrl, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({}) });
      await cartRequest(cartAddUrl, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }) });
      await cartRequest(cartUpdateUrl, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ note: buildNote() }) });
      window.location.href = checkoutUrl;
    } catch (err) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (errEl) { errEl.textContent = 'Something went wrong. Please try again.'; errEl.hidden = false; }
    }
  }
  const atc = $('[data-add-to-cart]');
  const atcSticky = $('[data-add-to-cart-sticky]');
  if (atc) atc.addEventListener('click', () => addToCart(atc));
  // The sticky scrolls to the real CTA instead of buying blind, so the
  // visitor passes the ask field and price on the way.
  if (atcSticky && atc) {
    atcSticky.addEventListener('click', () => {
      analytics('gateway_sticky_scroll', {});
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      atc.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    });
  }

  // countdown to the gateway close (display-only; hides once past)
  const cdWrap = $('[data-gw-countdown-wrap]');
  const cdOut = $('[data-gw-countdown]');
  const targetIso = root.dataset.deadlineIso || '';
  if (cdWrap && cdOut && targetIso) {
    const target = Date.parse(targetIso);
    if (!Number.isNaN(target)) {
      function tick() {
        const left = target - Date.now();
        if (left <= 0) { cdWrap.hidden = true; return; }
        const d = Math.floor(left / 86400000);
        const h = Math.floor((left % 86400000) / 3600000);
        const m = Math.floor((left % 3600000) / 60000);
        const s = Math.floor((left % 60000) / 1000);
        cdOut.textContent = (d > 0 ? d + 'd ' : '') + h + 'h ' + m + 'm ' + s + 's';
        cdWrap.hidden = false;
        setTimeout(tick, 1000);
      }
      tick();
    }
  }

  // sticky CTA from load until the real button is on screen
  const sticky = $('[data-gw-sticky]');
  if (sticky && atc) {
    const updateSticky = () => {
      const r = atc.getBoundingClientRect();
      sticky.hidden = r.top < window.innerHeight && r.bottom > 0;
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  }

  analytics('gateway_viewed', {});
})();
